<template>
    <form v-on:submit.prevent="onSubmit">
        <loading :loading="loading"></loading>
        <div class="row justify-content-center">
            <div class="container">
                <div class="daychosen row mb-3 align-items-center">
                    <div class="form-group col-md-6 offset-2">
                        <label for="date">Date</label>
                        <datepicker v-model="datechosen" :format="customFormatter" id="date"
                                    @input="onSelectDate(prices)"></datepicker>
                    </div>
                </div>
                <template v-for="(val, i) in prices">
                    <!--DATE-->
                    <div class="currencies row mb-3 align-items-center">

                        <div class="form-group col-md-3 offset-2">
                            <label for="assets">Currency</label>
                            <multiselect
                                    id="assets"
                                    v-model="val.currency"
                                    :options="pricesSelectArr"
                                    label="format" track-by="id"
                                    @input="onSelectPrice(val)"
                                    @remove="onRemovePrice(val)"
                                    select-label=""
                                    :disabled="!datechosen"
                            ></multiselect>
                        </div>

                        <!--            <div class="input-group col-md-2 mt-3">-->
                        <!--              <div class="input-group-addon">-->
                        <!--                <span class="input-group-text">EUR</span>-->
                        <!--              </div>-->
                        <!--              <input type="text" class="form-control text-right w-100" v-model="val.priceEUR" @input="onInput" @keydown="onInput" @blur="onInput">-->
                        <!--            </div>-->
                        <div class="input-group col-md-5 mt-3"
                             v-if="val.crypto || (val.currency && val.currency.symbol=== 'BGN') || !val.currency">
                            <div class="input-group-addon">
                                <span class="input-group-text">USD</span>
                            </div>
                            <input type="text" class="form-control text-right w-100" v-model="val.priceUSD"
                                   @input="onInput" @keydown="onInput" @blur="onInput">
                        </div>
                        <div class="input-group col-md-5 mt-3"
                             v-if="!val.crypto && (val.currency && val.currency.symbol !== 'BGN')">
                            <div class="input-group-addon">
                                <span class="input-group-text">BGN</span>
                            </div>
                            <input type="text" class="form-control text-right w-100" v-model="val.priceBGN"
                                   @input="onInput" @keydown="onInput" @blur="onInput">
                        </div>
                        <span class="mt-3 btn btn-outline-primary" style="cursor: pointer;"
                              v-if="i === prices.length - 1" @click="addCurrency">&#43;</span>
                        <span class="col-md-12 text-center" v-if="val.isNew && val.crypto && !datechosenBGN">Creating a new record for date {{ customFormatter(datechosen) }}. Please include USD/BGN <b>or</b> BGN/USD for this date.</span>
                    </div>
                </template>
            </div>
        </div>

        <div class="row mt-5 justify-content-center">
            <div class="form-group mr-4">
                <button :disabled="!canSubmit || !datechosen" class="btn btn-outline-success">Save data</button>
            </div>
        </div>
    </form>
</template>


<script>
  import axios from 'axios'
  import Datepicker from 'vuejs-datepicker'
  import Multiselect from 'vue-multiselect'
  import Decimal from 'decimal.js'
  import moment from 'moment'

  const API_V1_URL = process.env.API_V1_URL
  /* Decimal.set({ rounding: 5 }) */
  Decimal.set({toExpNeg: -14})

  /* eslint-disable no-multiple-empty-lines */
  /* eslint-disable no-trailing-spaces */
  export default {
    components: {
      Datepicker,
      Multiselect,
    },
    data() {
      return {
        loading: false,
        canSubmit: false,
        currencies: {},
        pricesSelectArr: [],
        datechosen: null,
        crypto: null,
        datechosenBGN: false,
        prices: [{
          date: '',
          name: '',
          currency: null,
          priceUSD: '',
          // priceEUR: '',
          priceBGN: '',
          crypto: true,
        }],
      }
    },
    computed: {
      getPrices() {
        return this.prices.slice()
      },
    },
    created() {

    },
    methods: {
      addCurrency() {
        this.prices.push({
          date: '',
          name: '',
          currency: '',
          priceUSD: '',
          // priceEUR: '',
          priceBGN: '',
          crypto: true,
        })
      },
      /**
       * Price select methods
       */
      onSelectDate(prices) {
        /**
         * Start loading
         */
        this.loading = true
        axios.get(API_V1_URL + `/prices/${this.customFormatter(this.datechosen, true)}/BGN`)
          .then((res) => {
            if (res.success) {
              this.datechosenBGN = res.data
              this.canSubmit = true
            } else {
              this.datechosenBGN = false
            }
          })
        axios.get(API_V1_URL + `/prices/?limit=4000&offset=0`)
          .then((res) => {
            var prices = []
            res.data.forEach((el) => {
              el.format = el.id + ' [' + el.symbol + ']'
              prices.push(el)
            })
            this.pricesSelectArr = prices
          })
          /**
           * Stop loading
           */
          .finally(() => {
            this.loading = false
          })
        for (let obj in prices) {
          this.onSelectPrice(prices[obj])
        }
      },
      onSelectPrice(obj) {
        if (obj && obj.currency) {
          axios.get(API_V1_URL + `/prices/${this.customFormatter(this.datechosen, true)}/${obj.currency.symbol}`)
            .then((res) => {
              obj.priceBGN = res.success ? res.data.priceBGN : ''
              // obj.priceEUR = res.success ? res.data.priceEUR : ''
              obj.priceUSD = res.success ? res.data.priceUSD : ''
              obj.isNew = !res.success
              this.onInput()
            })
          // if fiat is chosen
          if (obj.currency.symbol === 'USD' || obj.currency.symbol === 'BGN') {
            obj.crypto = false
            // if there is a new crypto exchange then we can submit
            // if (this.prices.find(function(el) {
            //   console.log(el.isNew)
            //   return el.isNew === true
            // })) {
            this.canSubmit = true
            // }
          } else {
            obj.crypto = true
          }
        }
        this.onInput()
      },
      onRemovePrice(obj) {
        obj.priceBGN = ''
        // obj.priceEUR = ''
        obj.priceUSD = ''
        obj.isNew = false
      },
      /**
       * Calculations
       */
      onInput(e) {
        if (e && e.target) {
          if (!RegExp('^-?[0-9]+([\\.][0-9]+)?$').test(e.target.value)) {
            e.target.value = e.target.value.replace(',', '.')
            e.target.classList.add('bg-warning')
          } else {
            e.target.classList.remove('bg-warning')
          }
        }
      },
      customFixed(str, num = 8) {
        const rgx = new RegExp(`-?\\d+\\.?\\d{0,${num}}`)
        str = (`${str}`).match(rgx)
        return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num)
      },
      customFormatter(date, isAjax) {
        if (isAjax) {
          return moment(date).format('YYYY-MM-DD')
        }
        return moment(date).format('DD.MM.YYYY')
      },
      onSubmit(e) {
        const ans = confirm('Are you sure you want to save the data?')
        if (!ans) {
          return
        }

        this.loading = true

        axios.post(API_V1_URL + `/prices/set`, {
          date: this.customFormatter(this.datechosen, true),
          prices: JSON.stringify(this.prices.map(price => {
            price.date = this.customFormatter(this.datechosen, true)
            price.currency = price.currency.symbol
            // price.name = price.currency.name
            return price
          })),
        })
          .then(res => {
            this.loading = false
            this.prices = [{
              date: '',
              currency: null,
              priceUSD: '',
              // priceEUR: '',
              priceBGN: '',
            }]
          })
      },
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .input-group-addon {
        padding: 0.375rem;
        font-size: 0.9rem;
    }

    td .multiselect {
        width: 5rem;
    }

    td .multiselect__single {
        font-size: 0.9em;
    }

    table {
        min-width: 1280px;
    }

    .daychosen >>> .vdp-datepicker input {
        padding: 0.375rem 0.75rem !important;
        border: 1px solid #e8e8e8;
        border-radius: 0.25rem;
        font-size: 1rem;
        line-height: 1.5;
    }

    .currencies >>> .multiselect__placeholder {
        margin-bottom: 0;
    }

    .currencies >>> .multiselect__tags {
        font-size: 16px;
        margin-bottom: 0;
        line-height: 25px;
        padding: 5px 40px 0 10px !important;
    }

    #assets {
        font-size: 14px;
    }

    .currencies >>> .multiselect__single,
    .currencies >>> .multiselect__input {
        line-height: 28px;
        padding-left: 0;
        margin-bottom: 0px;
    }

    @media only screen and (max-width: 1280px) {
        .list-group-item {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/-service-app/components/forms/PricesForm.vue